import { Component, Inject } from 'ng-metadata/core';
import { CitationTrailsExpandButtonService } from './citationTrailsExpandButton.service';
import { SearchService } from '../search.service';
import { PrimolyticsService, beacon } from '../../analytics/primolytics.service';
import { MediaQueries } from '../../infra/mediaQueries.service';
import { AnalyticsUtils } from '../../nddUtils/analyticsUtils.service';

@Component({
    selector: 'prm-citation-trails-expand-button',
    templateUrl: 'components/search/citationTrails/citation-trails-expand-button.html',
})


export class PrmCitationTrailsExpandButton {

    constructor(
        private citationTrailsExpandButtonService: CitationTrailsExpandButtonService,
        private searchService: SearchService,
        private primolyticsService: PrimolyticsService,
        @Inject('$location') private $location: ng.ILocationService,
        private mediaQueries: MediaQueries,
        private analyticsUtils: AnalyticsUtils) {  
    }

    public changeToggle(){    
        this.runBeacon();
        this.sendAnalytics();
        this.citationTrailsExpandButtonService.addParamToUrl((!this.toggleValue).toString());
        this.searchService.performCitationSearchInFulltextSearch();
    }

    @beacon({'p': 'citationTrail', 'op': 'expandResults'})
    public runBeacon() {
    }

    private sendAnalytics() {
        let payload = this.getAnalyticsPayload();
        this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.EXPAND_RESULTS, payload);
    }

    private getAnalyticsPayload() {
        return {
            'Refine Type': 'Expand Results',
            'Refine Action Type' : this.citationTrailsExpandButtonService.expandMyResultsForCitationTrail ? 'Activate' : 'Deactivate'
        }
    }


    get toggleValue(){
        return this.citationTrailsExpandButtonService.expandMyResultsForCitationTrail;
    }

    set toggleValue(value){
        this.citationTrailsExpandButtonService.expandMyResultsForCitationTrail = value;
    }

    
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/citationTrails/citationTrailsExpandButton.directive.ts